import { BUILDING_LOCKED_TOOLTIP_POSITION } from '@/map-phaser-new/constants'
import type { BuildingConfigInterface } from '@/map-phaser-new/interfaces'

export const clubhouseConfig: BuildingConfigInterface = {
  textureKey: 'clubsBuildings',
  frameKey: 'clubHouse',
  routeConfig: {
    routeName: 'ClubsHouse',
    soundName: 'click-map-artefact',
    isRouteParamIdNeeded: false,
  },
  positionX: 1945.5,
  positionY: 1176,
  depth: 4,
  originX: 0,
  keyForTranslateTitle: 'club.clubHouse',
  buildingTitleConfig: {
    positionX: 2215,
    positionY: 1458,
    depth: 7,
    textConfig: {
      originX: 0.5,
      fontName: 'Roboto Condensed',
      fontSize: '24px',
      fontWeight: 'normal',
      fontStyle: 'italic',
      fontColor: '#fff',
    },
    backgroundImageConfig: {
      textureName: 'common',
      frameNameRightSide: 'right_side',
      frameNameRightSideLocked: 'right_side_locked',
      originX: 0.5,
      widthCorrection: 100,
      heightCorrection: 10,
    },
  },
  outlineConfig: {
    framePostFix: '_outline',
    depth: 6,
    originX: 0,
    positionByLevel: {
      '1': { positionX: 1945.5, positionY: 1176 },
      '2': { positionX: 1945.5, positionY: 1176 },
      '3': { positionX: 1945.5, positionY: 1176 },
      '4': { positionX: 1945.5, positionY: 1176 },
    },
    textureKey: 'clubsBuildingsOutlines',
  },
  inputConfig: {
    useHandCursor: true,
  },
  buildingLockedConfig: {
    textureKey: 'clubsLockedBuildings',
    framePostfix: '_locked',
    lockImageTextureKey: 'lock',
    positionX: 2169.5,
    positionY: 1316,
    lockImageDepth: 6,
    depth: 5,
    tooltipConfig: {
      depth: 10,
      tooltipPosition: BUILDING_LOCKED_TOOLTIP_POSITION.Top,
      tooltipTextureHeight: '213px',
      tooltipTextureWidth: '444px',
      titleConfig: {
        originX: 0.5,
        fontSize: '30px',
        fontName: 'Roboto Condensed',
        fontWeight: 'normal',
        fontStyle: 'italic',
        fontColor: '#fff',
      },
      subtitleConfig: {
        originX: 0.5,
        originY: 0.5,
        fontName: 'Roboto Condensed',
        fontSize: '24px',
        fontWeight: 'normal',
        fontStyle: 'italic',
        fontColor: '#fff',
        replaceFontColor: '#fec742',
        tooltipSubtitleTranslateKey: 'common.comingSoon',
      },
      tooltipHideDelay: 2000,
      tooltipLeftTextureName: 'building_tooltip_left',
      tooltipRightTextureName: 'building_tooltip_right',
      tooltipTopTextureName: 'building_tooltip_top',
    },
  },
}
